module.exports = __webpack_public_path__ + "static/img/solucion.53eb119.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/services/solucion.jpg
// module id = aK8e
// module chunks = 1